var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCombatAndFightingGames = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Crime-Man-Ninja--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Crime Man Ninja Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.38 8.5v-2c0 -4.8 -4.33 -6.5 -6.5 -6.5s-6.5 1.79 -6.5 6.5v2a6.5 6.5 0 1 0 13 0ZM16.5 7a0.23 0.23 0 0 1 0.19 0.09 0.24 0.24 0 0 1 0.06 0.2c-0.36 2.17 -0.42 3.35 -2.05 3.84a9.54 9.54 0 0 1 -2.82 0.37 9.57 9.57 0 0 1 -2.83 -0.37C7.45 10.65 7.36 9.45 7 7.29a0.24 0.24 0 0 1 0.06 -0.2 0.23 0.23 0 0 1 0.19 -0.09Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 8.5a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88 8.5a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.51 16.75a0.25 0.25 0 0 0 0.24 0 0.26 0.26 0 0 0 0.13 -0.22V15a0.25 0.25 0 0 1 0.24 -0.25h0.76a0.75 0.75 0 0 0 0 -1.5h-0.76a0.25 0.25 0 0 1 -0.24 -0.25v-3a1.5 1.5 0 0 0 -3 0v3a0.26 0.26 0 0 1 -0.26 0.25h-0.74a0.75 0.75 0 1 0 0 1.5h0.74a0.26 0.26 0 0 1 0.26 0.25v0.2a0.26 0.26 0 0 0 0.13 0.22Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.41 18.42A11.78 11.78 0 0 0 20 17a0.24 0.24 0 0 0 -0.32 0.1l-0.86 1.58 -2.69 4.93a0.25 0.25 0 0 0 0.22 0.37h6.57a0.5 0.5 0 0 0 0.5 -0.5v-3.09a2.46 2.46 0 0 0 -1.01 -1.97Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46 15.9a14.53 14.53 0 0 0 -6.12 2.52 2.45 2.45 0 0 0 -1 2v3.08a0.5 0.5 0 0 0 0.5 0.5H8.2a0.25 0.25 0 0 0 0.19 -0.09l3.07 -3.56a0.25 0.25 0 0 0 0 -0.33l-3.52 -4a0.48 0.48 0 0 0 -0.48 -0.12Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.19 16.46a0.24 0.24 0 0 0 -0.17 -0.14c-0.24 -0.07 -0.49 -0.14 -0.76 -0.2a0.21 0.21 0 0 0 -0.24 0.08l-0.61 0.7 -5.76 6.69a0.25 0.25 0 0 0 0 0.26 0.25 0.25 0 0 0 0.23 0.15H14a0.25 0.25 0 0 0 0.22 -0.13L17.46 18l0.71 -1.31a0.28 0.28 0 0 0 0.02 -0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCombatAndFightingGames);
export default ForwardRef;